var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.53631 1.23187C8.13507 0.820106 7.32387 0.367953 6.89326 0.143278C6.76267 0.0751456 6.6098 0.170633 6.6098 0.317922V1.2678C6.6098 1.44285 6.70136 1.60476 6.84778 1.7007C7.06572 1.8435 7.3798 2.06184 7.55221 2.23944C8.96018 3.68691 8.96018 6.04032 7.55221 7.48707C6.14424 8.93164 3.85532 8.93164 2.44523 7.48707C1.03867 6.03887 1.03867 3.68691 2.44523 2.23944C2.44876 2.23509 2.46006 2.22783 2.46501 2.22129L3.12875 2.90101C3.19146 2.96523 3.30046 2.92072 3.3003 2.83097L3.29617 0.558689C3.29597 0.448482 3.20665 0.359205 3.09644 0.359053L0.88955 0.356023C0.801047 0.355902 0.756023 0.462342 0.817749 0.525767L1.48303 1.20937C1.47809 1.21808 1.47032 1.22679 1.46396 1.23187C-0.487986 3.23685 -0.487986 6.48966 1.46396 8.49464C3.41873 10.5018 6.58225 10.5018 8.53631 8.49464C10.4868 6.48966 10.489 3.23685 8.53631 1.23187Z",
    fill: "#42526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryIcon);
export default __webpack_public_path__ + "static/media/retry-icon.223c90e5.svg";
export { ForwardRef as ReactComponent };